import { createSelector } from 'reselect';
import { getSlips } from '../../modules/slip/selectors';

export const getTransferSlipId = state => state.getIn(['transfer', 'slipId']);

export const getTransferedSlip = createSelector(
  getSlips,
  getTransferSlipId,
  (slips, slipId) => slips.get(slipId)
);

export const canTransferSlip = createSelector(
  getTransferedSlip,
  slip => slip.slipStatus === 'settled'
);

export const countBetsToTransfer = createSelector(
  getTransferedSlip,
  slip => slip.bets.size
);

export const getPayoutToTransfer = createSelector(
  getTransferedSlip,
  slip => slip.slipTotalPayout
);
